import { Tag } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { BidV2Status } from "../../../autogen/bff-api";
import { deriveBidOutcome, type BidOutcome } from "./bidOutcome";

interface Props {
  status: BidV2Status;
  // True once the event has reached an award decision. A still-SUBMITTED bid then
  // reads as "not selected" rather than "submitted".
  awarded?: boolean;
  biddingClosed?: boolean;
  size?: "sm" | "md" | "lg";
}

const meta: Record<BidOutcome, { color: string; labelKey: string }> = {
  draft: { color: "gray", labelKey: "Draft" },
  notDelivered: { color: "orange", labelKey: "Not delivered" },
  submitted: { color: "green", labelKey: "Submitted" },
  awarded: { color: "teal", labelKey: "Awarded" },
  notSelected: { color: "purple", labelKey: "Not selected" },
  rejected: { color: "red", labelKey: "Rejected" },
};

export const BidV2StatusTag = ({
  status,
  awarded = false,
  biddingClosed = false,
  size = "sm",
}: Props) => {
  const { t } = useTranslation();
  const { color, labelKey } = meta[deriveBidOutcome(status, awarded, biddingClosed)];
  return (
    <Tag colorScheme={color} size={size} borderRadius="full">
      {t(labelKey)}
    </Tag>
  );
};
